import React from 'react';
import DokumenSk from './DigitalSign/DokumenSk';
import TambahDokumenSk from './DigitalSign/DokumenSk/TambahDokumen';
import SignDokumenSk from './DigitalSign/DokumenSk/SignDokumenSk';
import DetailDokumenSk from './DigitalSign/DokumenSk/DetailDokumen';
import DokumenPk from './DigitalSign/DokumenPk';

const Page1 = React.lazy(() => import('./Page1'));
const Page2 = React.lazy(() => import('./Page2'));
const Pegawai = React.lazy(() => import('./Pegawai'));
const ProfilePegawai = React.lazy(() => import('../profile/Profile'));
const Bankom = React.lazy(() => import('./DigitalSign/Bankom'));
const Laporan = React.lazy(() => import('./DigitalSign/Laporan'));
// Dokumen Lain
// const DokumenLain = React.lazy(() => import('./DigitalSign/DokumenLain'));
const DokumenLainV2 = React.lazy(() => import('./DigitalSign/DokumenLainV2'));
const TambahDokumenLainV2 = React.lazy(() => import('./DigitalSign/DokumenLainV2/TambahDokumen'));
const SignDokumenLainV2 = React.lazy(() => import('./DigitalSign/DokumenLainV2/SignDokumenLain'));
const DetailDokumenLainV2 = React.lazy(() => import('./DigitalSign/DokumenLainV2/DetailDokumen'));
// Perizinan Menteri
const PerizinanMenteri = React.lazy(() => import('./DigitalSign/PerizinanMenteri'));
const DetailPerizinanMenteri = React.lazy(() => import('./DigitalSign/PerizinanMenteri/Esea/DetailDokumen'));
const SignPerizinanMenteri = React.lazy(() => import('./DigitalSign/PerizinanMenteri/SignPerizinanMenteri'));

const DetailBerita = React.lazy(() => import('./DetailBerita'));
// Sertifikat LMS
const SertifikatLMS = React.lazy(() => import('./DigitalSign/SertifikatLMS'));
// Sertifikat External
const SertifikatExternal = React.lazy(() => import('./DigitalSign/SertifikatExternal'));
const MenuSetting = React.lazy(() => import('./MenuSetting'));
// PKRL
const TambahPerizinanMenteriPKRL = React.lazy(() => import('./DigitalSign/PerizinanMenteri/PKRL/TambahDokumen'));
const DetailPerizinanMenteriPKRL = React.lazy(() => import('./DigitalSign/PerizinanMenteri/PKRL/DetailDokumen'));
// Produk LPMUKP
const ProdukLPMUKP = React.lazy(() => import('./DigitalSign/ProdukLPMUKP'));
const NewDetailProdukLPMUKP = React.lazy(() => import('./DigitalSign/ProdukLPMUKP/NewDetailProdukLPMUKP'));
// Dashboard Dokumen
const DashboardDokumen = React.lazy(() => import('./DigitalSign/DashboardDokumen'));
// Sertifikat Menteri
const SertifikatMenteri = React.lazy(() => import('./DigitalSign/SertifikatMenteri'));
const TambahSertifikatMenteri = React.lazy(() => import('./DigitalSign/SertifikatMenteri/TambahSertifikat'));
const DetailSertifikatMenteri = React.lazy(() => import('./DigitalSign/SertifikatMenteri/DetailSertifikatMenteri'));
// Siap Mutu
const SiapMutu = React.lazy(() => import('./DigitalSign/SiapMutu'));
const DetailSiapMutu = React.lazy(() => import('./DigitalSign/SiapMutu/DetailDokumen'));
const SignSiapMutu = React.lazy(() => import('./DigitalSign/SiapMutu/SignSiapMutu'));

export const samplePagesConfigs = [
  {
    path: '/kkp',
    element: <Page1 />,
    permittedRole: ['honorer', 'pegawai']
  },
  {
    path: '/satker',
    element: <Page2 />,
    permittedRole: ['honorer', 'pegawai']
  },
  {
    path: '/pegawai',
    element: <Pegawai />,
    permittedRole: ['honorer', 'pegawai']
  },
  {
    path: '/pegawai/:id',
    element: <ProfilePegawai />,
    permittedRole: ['honorer', 'pegawai']
  },
  // Bankom
  {
    path: '/apps/sertifikat-ttde',
    element: <Bankom />,
  },
  {
    path: '/apps/sertifikat-ttde/tambah',
    element: <Bankom />,
  },
  {
    path: '/apps/sertifikat-ttde/detail/:id',
    element: <Bankom />,
  },
  {
    path: '/apps/sertifikat-ttde/tambah/:id',
    element: <Bankom />,
  },
  {
    path: '/apps/sertifikat-ttde/tanda-tangan',
    element: <Bankom />,
  },
  {
    path: '/apps/sertifikat-ttde/template-titik',
    element: <Bankom />,
  },
  {
    path: '/apps/sertifikat-ttde/template-titik/tambah',
    element: <Bankom />,
  },
  // Laporan Bankom
  {
    path: '/apps/laporan-bankom',
    element: <Laporan />,
    roleAccess: ['LAPORAN_BSRE', 'MONITORING_DIGITAL_SIGN'],
  },
  // Sertifikat LMS
  {
    path: '/apps/sertifikat-lms',
    element: <SertifikatLMS />,
  },
  {
    path: '/pengaturan-menu',
    element: <MenuSetting />,
  },
  // Dokumen Lain
  {
    path: '/apps/dokumen-lain',
    element: <DokumenLainV2 />,
  },
  {
    path: '/apps/dokumen-lain/tambah-dokumen',
    element: <TambahDokumenLainV2 />,
  },
  {
    path: '/apps/dokumen-lain/detail/:id',
    element: <DetailDokumenLainV2 />,
  },
  {
    path: '/apps/dokumen-lain/tambah-dokumen/:id',
    element: <TambahDokumenLainV2 />,
  },
  {
    path: '/apps/dokumen-lain/tanda-tangan',
    element: <SignDokumenLainV2 />,
  },
  // Dokumen SK
  {
    path: '/apps/dokumen-sk',
    element: <DokumenSk />,
  }, 
  {
    path: '/apps/dokumen-sk/tambah-dokumen/:type',
    element: <TambahDokumenSk />,
    roleAccess: ['DIGISIGN.SK', 'MONITORING_DIGITAL_SIGN', 'DIGISIGN.SK.PPID', 'DIGISIGN.SK.DIRJEN']
  },
  {
    path: '/apps/dokumen-sk/detail/:type/:id',
    element: <DetailDokumenSk />,
  },
  {
    path: '/apps/dokumen-sk/tambah-dokumen/:type/:id',
    element: <TambahDokumenSk />,
    roleAccess: ['DIGISIGN.SK', 'MONITORING_DIGITAL_SIGN', 'DIGISIGN.SK.PPID', 'DIGISIGN.SK.DIRJEN']
  },
  {
    path: '/apps/dokumen-sk/tanda-tangan',
    element: <SignDokumenSk />,
  },
  // Dokumen PK
  {
    path: '/apps/dokumen-pk',
    element: <DokumenPk />,
  },
  {
    path: '/apps/dokumen-pk/detail/:id',
    element: <DokumenPk />,
  }, {
    path: '/apps/dokumen-pk/tambah-dokumen',
    element: <DokumenPk />,
  },
  {
    path: '/apps/dokumen-pk/tambah-dokumen/:id',
    element: <DokumenPk />,

  },
  {
    path: '/apps/dokumen-pk/tanda-tangan',
    element: <DokumenPk />,
  },
  // Perizinan Menteri
  {
    path: '/apps/perizinan-menteri',
    element: <PerizinanMenteri />,
  },
  {
    path: '/apps/perizinan-menteri/detail/:id',
    element: <DetailPerizinanMenteri />,
  },
  {
    path: '/apps/perizinan-menteri/tanda-tangan',
    element: <SignPerizinanMenteri />,
  },
  // PKRL
  {
    path: '/apps/perizinan-menteri/pkrl',
    element: <PerizinanMenteri />,
    roleAccess: ['PERIZINAN_MENTERI', 'MONITORING_DIGITAL_SIGN']
  },
  {
    path: '/apps/perizinan-menteri/pkrl/dashboard',
    element: <PerizinanMenteri />,
    roleAccess: ['PERIZINAN_MENTERI', 'MONITORING_DIGITAL_SIGN']
  },
  {
    path: '/apps/perizinan-menteri/pkrl/tambah-dokumen',
    element: <TambahPerizinanMenteriPKRL />,
    roleAccess: ['OPERATOR_PERIZINAN_MENTERI']
  },
  {
    path: '/apps/perizinan-menteri/pkrl/tambah-dokumen/:id',
    element: <TambahPerizinanMenteriPKRL />,
    roleAccess: ['OPERATOR_PERIZINAN_MENTERI']
  },
  {
    path: '/apps/perizinan-menteri/pkrl/detail/:id',
    element: <DetailPerizinanMenteriPKRL />,
    roleAccess: ['PERIZINAN_MENTERI', 'MONITORING_DIGITAL_SIGN']
  },
  // Produk LPMUKP
  {
    path: '/apps/produk-lpmukp',
    element: <ProdukLPMUKP />,
    roleAccess: ['PRODUK.LPMUKP']
  },
  {
    path: '/produk-lpmukp/new-detail/:id',
    element: <NewDetailProdukLPMUKP />,
    roleAccess: ['PRODUK.LPMUKP']
  },
  {
    path: '/kkp/berita/:id',
    element: <DetailBerita />,
  },
  {
    path: '/satker/berita/:id',
    element: <DetailBerita />,
  },
  // Sertifikat Eksternal
  {
    path: '/apps/sertifikat-eksternal',
    element: <SertifikatExternal />,
  },
  {
    path: '/apps/sertifikat-eksternal/tambah',
    element: <SertifikatExternal />,
  },
  {
    path: '/apps/sertifikat-eksternal/detail/:id',
    element: <SertifikatExternal />,
  },
  // Dashboard Dokumen
  {
    path: '/apps/dashboard-dokumen',
    element: <DashboardDokumen />,
    roleAccess: ['MONITORING_DIGITAL_SIGN']
  },
  // Sertifikat Menteri
  {
    path: '/apps/sertifikat-menteri',
    element: <SertifikatMenteri />,
    roleAccess: ['SERTIFIKAT_MENTERI', 'MONITORING_DIGITAL_SIGN']
  },
  {
    path: '/apps/sertifikat-menteri/tambah',
    element: <TambahSertifikatMenteri />,
    roleAccess: ['OPERATOR_BSRE']
  },
  {
    path: '/apps/sertifikat-menteri/detail/:id',
    element: <DetailSertifikatMenteri />,
    roleAccess: ['SERTIFIKAT_MENTERI', 'MONITORING_DIGITAL_SIGN']
  },
  {
    path: '/apps/sertifikat-menteri/tambah/:id',
    element: <DetailSertifikatMenteri />,
    roleAccess: ['OPERATOR_BSRE']
  },
  // Siap Mutu
  {
    path: '/apps/siap-mutu',
    element: <SiapMutu />,
    roleAccess: ['SIAP_MUTU', 'MONITORING_DIGITAL_SIGN', 'OPERATOR_SIAP_MUTU', 'APPROVERS.DIGISIGN.SIAPMUTU'],
  },
  {
    path: '/apps/siap-mutu/detail/:id',
    element: <DetailSiapMutu />,
    roleAccess: ['SIAP_MUTU', 'MONITORING_DIGITAL_SIGN', 'OPERATOR_SIAP_MUTU', 'APPROVERS.DIGISIGN.SIAPMUTU'],
  },
  {
    path: '/apps/siap-mutu/tanda-tangan',
    element: <SignSiapMutu />,
    roleAccess: ['SIAP_MUTU', 'MONITORING_DIGITAL_SIGN', 'OPERATOR_SIAP_MUTU', 'APPROVERS.DIGISIGN.SIAPMUTU'],
  },
];
